/**
 * T067: useCreatePrompt Hook
 * Mutation hook for creating prompts with cache invalidation
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { createPrompt, type CreatePromptInput } from '@/services/prompts'
import { queryKeys } from '@/lib/query-keys'

export function useCreatePrompt() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation({
    mutationFn: (input: CreatePromptInput) => createPrompt(input),
    onSuccess: (data) => {
      // Invalidate prompts list
      queryClient.invalidateQueries({ queryKey: queryKeys.prompts.all })
      // Navigate to the new prompt
      navigate({ to: '/prompts/$id', params: { id: data.id } })
    },
  })
}
